import { ContractPropertyName } from '../../../constants';
import { Helper } from '../Helper';
export class IsDeployedHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.emitPushString(node, ContractPropertyName.deployed);
        sb.emitHelper(node, options, sb.helpers.getCommonStorage);
        sb.emitHelper(node, options, sb.helpers.handleUndefinedStorage({
            handleUndefined: () => {
                sb.emitPushBoolean(node, false);
            },
            handleDefined: () => {
                sb.emitHelper(node, options, sb.helpers.unwrapBoolean);
            },
        }));
    }
}

//# sourceMappingURL=IsDeployedHelper.js.map
